import { PROCESS_STEPS } from "@/data/content";

const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
            <span className="h-px w-8 bg-magenta" />
            Cum lucrăm
          </div>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
            Patru pași.{" "}
            <span className="text-electric">Zero ambiguitate.</span>
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Un proces clar, repetabil, care funcționează de la primul kickoff până la scalare.
          </p>
        </div>

        <div className="mt-14 lg:mt-20 relative">
          {/* Connecting line on desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-[#E91E8B] via-slate-300 to-[#2962FF] opacity-50" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {PROCESS_STEPS.map((step, i) => {
              const color = i % 2 === 0 ? "#E91E8B" : "#2962FF";
              return (
                <div key={step.n} data-testid={`process-step-${i + 1}`} className="relative">
                  <div
                    className="relative h-12 w-12 rounded-2xl bg-white border-2 grid place-items-center font-display font-extrabold text-lg z-10 mx-auto lg:mx-0"
                    style={{ borderColor: color, color }}
                  >
                    {step.n}
                  </div>
                  <h3 className="font-display mt-6 text-2xl font-bold text-slate-900 text-center lg:text-left">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-slate-600 leading-relaxed text-center lg:text-left">
                    {step.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
